/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const CardTransactionFailureCode = {
  CallIssuer: "call-issuer",
  DoNotHonor: "do-not-honor",
  ProcessingError: "processing-error",
  InvalidTransaction: "invalid-transaction",
  InvalidAmount: "invalid-amount",
  NoSuchIssuer: "no-such-issuer",
  ReenterTransaction: "reenter-transaction",
  CvvMismatch: "cvv-mismatch",
  LostOrStolen: "lost-or-stolen",
  InsufficientFunds: "insufficient-funds",
  InvalidCardNumber: "invalid-card-number",
  InvalidMerchant: "invalid-merchant",
  ExpiredCard: "expired-card",
  IncorrectPin: "incorrect-pin",
  TransactionNotAllowed: "transaction-not-allowed",
  SuspectedFraud: "suspected-fraud",
  AmountLimitExceeded: "amount-limit-exceeded",
  VelocityLimitExceeded: "velocity-limit-exceeded",
  RevocationOfAuthorization: "revocation-of-authorization",
  CardNotActivated: "card-not-activated",
  IssuerNotAvailable: "issuer-not-available",
  CouldNotRoute: "could-not-route",
  CardholderAccountClosed: "cardholder-account-closed",
  UnknownIssue: "unknown-issue",
  DuplicateTransaction: "duplicate-transaction",
} as const;
export type CardTransactionFailureCode = ClosedEnum<
  typeof CardTransactionFailureCode
>;

/** @internal */
export const CardTransactionFailureCode$inboundSchema: z.ZodNativeEnum<
  typeof CardTransactionFailureCode
> = z.nativeEnum(CardTransactionFailureCode);
/** @internal */
export const CardTransactionFailureCode$outboundSchema: z.ZodNativeEnum<
  typeof CardTransactionFailureCode
> = CardTransactionFailureCode$inboundSchema;
